import { useAuth } from '@/context/AuthContext';
import { isAdmin } from '@/lib/admin';

export const useAdmin = () => {
  const { user } = useAuth();
  return isAdmin(user?.id);
};
